import React, { useState } from 'react';
import { useAuth } from '../context/AuthContext';
import { getVisibleNavItems, getDashboardConfig, canSwitchOrganization } from '../utils/rbac';
import Sidebar from './Sidebar';
import TopBar from './TopBar';

const DashboardLayout = ({ children }) => {
  const { user } = useAuth();
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [selectedCustomerId, setSelectedCustomerId] = useState(null);

  if (!user) {
    return (
      <div className="min-h-screen bg-gray-50 flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  const navItems = getVisibleNavItems(user) || [];
  const dashboardConfig = getDashboardConfig(user) || { title: 'Dashboard', subtitle: '', showOrgSwitcher: false };

  return (
    <div className="min-h-screen bg-white flex">
      {/* Sidebar */}
      <Sidebar
        navItems={navItems}
        isOpen={sidebarOpen}
        onClose={() => setSidebarOpen(false)}
        user={user}
      />

      {/* Main content */}
      <div className="flex-1 flex flex-col lg:pl-64">
        {/* Top bar */}
        <TopBar
          user={user}
          dashboardConfig={dashboardConfig}
          selectedCustomerId={selectedCustomerId}
          onCustomerChange={setSelectedCustomerId}
          onMenuClick={() => setSidebarOpen(true)}
        />

        {/* Page content */}
        <main className="flex-1 py-6">
          <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
            {children}
          </div>
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;